function injectStyle (ssrContext) {
  require("!!../../../../../../webs/宇宙之幂/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../webs/宇宙之幂/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-5d67e86a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../../webs/宇宙之幂/node_modules/vue-loader/lib/selector?type=styles&index=0!./yuzhouzk.vue")
}
var normalizeComponent = require("!../../../../../../webs/宇宙之幂/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../../../webs/宇宙之幂/node_modules/vue-loader/lib/selector?type=script&index=0!./yuzhouzk.vue"
import __vue_script__ from "!!babel-loader!../../../../../../webs/宇宙之幂/node_modules/vue-loader/lib/selector?type=script&index=0!./yuzhouzk.vue"
/* template */
import __vue_template__ from "!!../../../../../../webs/宇宙之幂/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5d67e86a\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../../../webs/宇宙之幂/node_modules/vue-loader/lib/selector?type=template&index=0!./yuzhouzk.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/main/yuzhouzk.vue
// module id = null
// module chunks = 